import React, { useMemo, useState } from 'react';

import Icon from 'components/DesignSystem/Icon';
import { ProductCardEntry } from 'helper/Home/productCardList';
import { cssVar } from 'constants/theme';
import ProductModuleItem from './ProductModuleItem';

import './index.scss';

export default function MobileProductModuleList({
  title,
  products,
  sectionTabs,
}: {
  title: string;
  products: ProductCardEntry[];
  sectionTabs?: React.ReactNode;
}) {
  const [search, setSearch] = useState<string>('');
  const [openId, setOpenId] = useState<string | null>(null);

  const filteredProducts = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) {
      return products;
    }
    return products.filter((product) => product.name.toLowerCase().includes(query));
  }, [products, search]);

  return (
    <div className="mobile-product-module-list">
      <div className="mobile-product-module-header">
        <h1>{title}</h1>
        <span className="mobile-product-module-count">
          {products.length}
          {' '}
          módulo
          {products.length === 1 ? '' : 's'}
        </span>
      </div>

      {sectionTabs}

      <div className="mobile-product-module-search">
        <Icon iconType="search" color={cssVar('text-muted')} size="small" />
        <input
          type="search"
          aria-label="Buscar recurso"
          placeholder="Buscar recurso…"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
        />
      </div>

      <div className="mobile-product-module-card">
        {filteredProducts.length === 0 ? (
          <p className="mobile-product-module-empty">Nenhum resultado encontrado.</p>
        ) : (
          filteredProducts.map((product) => (
            <ProductModuleItem
              key={product.id}
              product={product}
              isOpen={openId === product.id}
              onToggle={() => setOpenId((current) => (current === product.id ? null : product.id))}
            />
          ))
        )}
      </div>
    </div>
  );
}
